import { ButtonLink } from './ButtonLink';

export { ButtonLink };
export type { ButtonLinkProps } from './ButtonLink';

export default ButtonLink;
